import React, { useEffect, useState } from "react";
import { Alert, Box, CircularProgress } from "@mui/material";
import { loadConfig } from "./api";
import Account from "./Account";
import PaymentDemo from "./PaymentDemo";

/**
 * Client demo for transaction signing: the bank creates a payment, the user approves
 * or rejects it on the phone, and the bank executes only the approved details.
 * The bank backend is the docs server's /mock-bank, which holds the app's API secret.
 */
export default function SecurityDemo() {
  const [config, setConfig] = useState(null);
  const [error, setError] = useState("");
  const [username, setUsername] = useState("");

  useEffect(() => {
    loadConfig()
      .then(setConfig)
      .catch((e) => setError(`Could not reach the demo bank backend: ${e.message}`));
  }, []);

  return (
    <Box sx={{ maxWidth: 1000 }}>
      <h1 className="pwl_heading">Transaction Signing Demo</h1>
      <p className="pwl_subheading">
        The bank creates a payment, the user approves or rejects it on the phone with a biometric, and the bank can only
        execute the exact details that were approved.
      </p>

      {error && <Alert severity="error">{error}</Alert>}
      {!config && !error && <CircularProgress />}
      {config && !config.configured && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          The mock bank has no API secret. Set DEMO_CLIENT_ID and DEMO_API_SECRET on the docs server (generate the secret
          in the dashboard: Application, API Secret). Add this site's origin ({window.location.origin}) to the app's allowed
          origins.
        </Alert>
      )}

      {config && (
        <>
          <Account config={config} username={username} onUsername={setUsername} />
          <PaymentDemo username={username} />
        </>
      )}
    </Box>
  );
}
